import React from "react";
import { Tag, Sparkles } from "lucide-react";
import { Reveal } from "../../lib/motion";

const scrollToBook = () => {
  const el = document.getElementById("book");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Promotions = () => {
  return (
    <section id="offers" className="py-24 md:py-32" data-testid="offers-section">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-14">
            <p className="font-body text-xs uppercase tracking-[0.3em] text-[#c96c31] mb-5">
              Limited-Time Offers
            </p>
            <h2 className="font-display font-light leading-[0.95] tracking-tight text-[#2c1e16] text-4xl sm:text-5xl lg:text-6xl">
              Elevated looks, <span className="italic text-[#c96c31]">elevated value</span>
            </h2>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Reveal>
            <div
              data-testid="promo-percent"
              className="h-full rounded-3xl bg-[#2c1e16] text-[#f9f6f0] p-10 md:p-12 flex flex-col justify-between min-h-[300px]"
            >
              <Sparkles className="text-[#c96c31]" size={30} />
              <div>
                <p className="font-display text-6xl md:text-7xl leading-none">
                  10<span className="text-[#c96c31]">–</span>30%
                </p>
                <p className="font-display text-2xl md:text-3xl mt-3">off all braiding services</p>
                <p className="font-body text-sm text-[#f9f6f0]/60 mt-4 max-w-sm">
                  Every twist, braid and cornrow — discounted across the board while the offer lasts.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div
              data-testid="promo-dollar"
              className="h-full rounded-3xl border border-[#2c1e16]/15 bg-[#f3ebe1] p-10 md:p-12 flex flex-col justify-between min-h-[300px]"
            >
              <Tag className="text-[#c96c31]" size={30} />
              <div>
                <div className="flex items-baseline gap-4 font-display text-[#2c1e16]">
                  <span className="text-5xl md:text-6xl">$20</span>
                  <span className="text-4xl md:text-5xl text-[#2c1e16]/70">$30</span>
                  <span className="text-3xl md:text-4xl text-[#2c1e16]/50">$40</span>
                </div>
                <p className="font-display text-2xl md:text-3xl mt-3 text-[#2c1e16]">style-based discounts</p>
                <p className="font-body text-sm text-[#2c1e16]/60 mt-4 max-w-sm">
                  Save $20, $30 or $40 depending on the style you choose. Ask us which offer fits your look.
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="mt-10 text-center">
            <button
              data-testid="promo-claim-btn"
              onClick={scrollToBook}
              className="rounded-full bg-[#c96c31] px-9 py-4 font-body text-sm font-medium uppercase tracking-wider text-[#f9f6f0] hover:bg-[#b35d27] hover:-translate-y-1 transition-all duration-300"
            >
              Claim Your Discount
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
